import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { Pill, Radio, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { DurationLabel } from './DurationLabel';

export const ShortestDurationOption = ({
    offer,
    drawdownAmount
}: {
    offer: TFormalOffer;
    drawdownAmount: number;
}) => (
    <Radio.Root>
        <Radio.Label className="!flex w-full flex-col gap-xs !font-reg">
            <DurationLabel offer={offer} drawdownAmount={drawdownAmount} />
            <Text className="text-s text-structure-40">
                <FormattedMessage
                    id="_.offer_choice_buttons.offer_description_shortest"
                    defaultMessage="Repay quickly and minimise interest."
                />
            </Text>
            <Pill className="mt-xs self-start" variant="green" size="small">
                <FormattedMessage
                    id="_.offer_choice_buttons.lowest_total_cost_pill"
                    defaultMessage="Lowest total cost"
                />
            </Pill>
        </Radio.Label>
        <Radio.Input className="self-start" value={offer.offer_id!} />
    </Radio.Root>
);
